(function () {
  var html = document.documentElement;
  html.classList.add('js');
  /* Full-page capture mode for review screenshots (?cap=1): fixed hero height, no loader */
  if (/[?&]cap=/.test(location.search)) html.classList.add('capture');

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stored = null;
  try { stored = localStorage.getItem('rillby-motion'); } catch (e) {}
  var reduce = mqReduce.matches || stored === 'reduce';
  if (reduce) html.classList.add('reduce-motion');

  /* Motion toggle (footer) */
  var toggle = document.getElementById('motionToggle');
  function paintToggle() {
    var on = html.classList.contains('reduce-motion');
    toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
    toggle.textContent = on ? 'MOVIMENTO NORMAL' : 'MENOS MOVIMENTO';
  }
  if (toggle) {
    paintToggle();
    toggle.addEventListener('click', function () {
      var on = html.classList.toggle('reduce-motion');
      try { localStorage.setItem('rillby-motion', on ? 'reduce' : 'full'); } catch (e) {}
      paintToggle();
    });
  }

  /* Preloader: count to 100 with rotating walk tips, then lift */
  var loader = document.getElementById('loader');
  var count = document.getElementById('loaderCount');
  var tip = document.getElementById('loaderTip');
  var tips = [
    'DICA DE PASSEIO 01 — LEVA ÁGUA PRA VOCÊ E PRA ELE.',
    'DICA DE PASSEIO 02 — SE O ASFALTO QUEIMA SUA MÃO, QUEIMA A PATA DELE.',
    'DICA DE PASSEIO 03 — PAUSAS CURTAS VALEM MAIS QUE UM GOLE LONGO NO FIM.',
    'DICA DE PASSEIO 04 — PRONTA PRA SAIR.'
  ];
  function finishLoad() {
    html.classList.remove('is-loading');
    if (loader) loader.classList.add('is-done');
    document.body.classList.add('is-in');
  }
  if (reduce || !loader || html.classList.contains('capture')) {
    finishLoad();
  } else {
    html.classList.add('is-loading');
    var start = Date.now(), dur = 1500, lastTip = -1;
    var timer = setInterval(function () {
      var t = Math.min(1, (Date.now() - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      count.textContent = 'CARREGANDO ' + Math.round(e * 100) + '%';
      var ti = Math.min(tips.length - 1, Math.floor(t * tips.length));
      if (ti !== lastTip) { lastTip = ti; tip.textContent = tips[ti]; }
      if (t >= 1) { clearInterval(timer); setTimeout(finishLoad, 160); }
    }, 40);
    /* Safety: never trap the visitor behind the loader */
    setTimeout(function () { if (html.classList.contains('is-loading')) { clearInterval(timer); finishLoad(); } }, 3500);
  }

  /* Fullscreen menu */
  var menu = document.getElementById('menu');
  var openBtn = document.getElementById('menuOpen');
  var closeBtn = document.getElementById('menuClose');
  function setMenu(open) {
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) closeBtn.focus(); else openBtn.focus();
  }
  if (menu && openBtn && closeBtn) {
    openBtn.addEventListener('click', function () { setMenu(true); });
    closeBtn.addEventListener('click', function () { setMenu(false); });
    menu.querySelectorAll('[data-menu-link]').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setMenu(false);
    });
  }

  /* Nav background after the hero */
  var nav = document.getElementById('nav');
  var heroDog = document.getElementById('heroDog');
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || window.pageYOffset;
      nav.classList.toggle('is-scrolled', y > 40);
      if (heroDog && !html.classList.contains('reduce-motion') && window.innerWidth >= 760 && y < window.innerHeight * 1.2) {
        heroDog.style.setProperty('--py', (y * 0.16).toFixed(1) + 'px');
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Colour swap on the bottle */
  var swatches = document.querySelectorAll('.swatch');
  var bottleImgs = document.querySelectorAll('.bottle__img');
  function setColor(c) {
    swatches.forEach(function (b) {
      var on = b.dataset.swatch === c;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    bottleImgs.forEach(function (img) { img.classList.toggle('is-active', img.dataset.color === c); });
  }
  swatches.forEach(function (b) {
    b.addEventListener('click', function () { setColor(b.dataset.swatch); });
    b.addEventListener('mouseenter', function () { setColor(b.dataset.swatch); });
  });

  /* Reveal on scroll: one grammar for every section */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !html.classList.contains('reduce-motion')) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Notify form (prototype: validates, stores nothing) */
  var form = document.getElementById('notifyForm');
  var msg = document.getElementById('notifyMsg');
  if (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      var v = (input.value || '').trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      msg.classList.toggle('is-error', !ok);
      if (!ok) {
        e.preventDefault();
        msg.textContent = 'Esse e-mail está faltando um pedaço. Tenta de novo.';
        input.focus();
        return;
      }
      /* data-live: the Shopify customer form submits for real; the prototype only confirms */
      if (form.hasAttribute('data-live')) return;
      e.preventDefault();
      msg.textContent = 'Você está na lista. Um e-mail quando o primeiro lote estiver pronto.';
      form.reset();
    });
  }
})();


/* Rillby — shop pages. Appended to rillby.js by build-theme.py */
(function () {
  /* Quantity steppers (product + cart) */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    var form = box.closest('form');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 0;
        v = b.dataset.step === 'down' ? Math.max(min, v - 1) : v + 1;
        input.value = v;
        if (box.hasAttribute('data-autosubmit') && form) form.submit();
      });
    });
  });

  /* Product: variant picker, price, availability, media */
  var pform = document.getElementById('pdpForm');
  if (pform) {
    var data = document.getElementById('pdpVariants');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = pform.querySelector('input[name="id"]');
    var price = document.getElementById('pdpPrice');
    var compare = document.getElementById('pdpCompare');
    var btn = document.getElementById('pdpAdd');
    var btnLabel = btn ? btn.querySelector('span:first-child') : null;
    var values = document.querySelectorAll('[data-opt-value]');
    var imgs = document.querySelectorAll('.pdp__img');
    var thumbs = document.querySelectorAll('.pdp__thumb');

    function showMedia(id) {
      if (!id) return;
      var hit = false;
      imgs.forEach(function (im) { var on = im.dataset.media === String(id); im.classList.toggle('is-active', on); if (on) hit = true; });
      if (!hit) return;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.media === String(id)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.media); });
    });

    function selected() {
      var out = [];
      pform.querySelectorAll('.opt').forEach(function (opt) {
        var on = opt.querySelector('input:checked');
        out.push(on ? on.value : null);
      });
      return out;
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function paintOffStates(sel) {
      /* grey a value when no available variant uses it together with the other current choices */
      pform.querySelectorAll('.opt').forEach(function (opt, oi) {
        opt.querySelectorAll('input').forEach(function (inp) {
          var test = sel.slice(); test[oi] = inp.value;
          var any = variants.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j < test.length; j++) if (test[j] !== null && j !== oi && v.options[j] !== test[j]) return false;
            return v.options[oi] === inp.value;
          });
          inp.nextElementSibling.classList.toggle('is-off', !any);
        });
      });
    }
    function update() {
      var sel = selected();
      var v = findVariant(sel);
      values.forEach(function (el) {
        var i = parseInt(el.dataset.optValue, 10);
        el.textContent = sel[i] || '';
      });
      paintOffStates(sel);
      if (!v) {
        if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'UNAVAILABLE'; }
        return;
      }
      idInput.value = v.id;
      if (price) price.textContent = v.price;
      if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
      if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? 'ADICIONAR AO CARRINHO' : 'ESGOTADA'; }
      if (v.media) showMedia(v.media);
      if (history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      }
    }
    pform.querySelectorAll('.opt input').forEach(function (inp) { inp.addEventListener('change', update); });
    update();

    /* Add to cart without leaving the page, then send them to the cart */
    pform.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var msg = document.getElementById('pdpMsg');
      if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = 'ADICIONANDO…'; }
      var fd = new FormData(pform);
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Não deu pra adicionar ao carrinho.');
          location.href = pform.dataset.cartUrl || '/cart';
        })
        .catch(function (err) {
          if (msg) msg.textContent = err.message + ' Tenta de novo.';
          if (btn) { btn.disabled = false; if (btnLabel) btnLabel.textContent = 'ADICIONAR AO CARRINHO'; }
        });
    });
  }
})();
